import React, { useEffect, useRef, useState } from "react";

import { useRouter } from "@src/lib/router";
import { useSelector, useDispatch } from "react-redux";
import { checkPaymentStatusGetService } from "@src/PaymentService/services";
import handleBackEvent from "@src/utils/goBack";
import PullToRefresh from "@src/components/PullToRefresh";

// ACTIONS
import * as actionCreator from "../components/BottomSheets/store/actions";
import CONSTANTS from "@src/components/Tabs/LiveClasses/store/constants";

// COMPONENTS
import LayoutFooter from "./LayoutFooter";
import LayoutHeader from "./LayoutHeader";
import LayoutContent from "./LayoutContent";

// STY:ES
import styles from "./Layout.module.scss";
import { getCourseContentAction, getTrialCourseContentAction } from "../components/Tabs/Content/store/actions";
import { getTabListAction } from "../components/UIElements/TabBar/store/actions";
import {
  getCourseDetailsAction,
  setPrevOrderId,
  updateIsInstallmentPaymentAction,
} from "../components/Tabs/Overview/store/actions";
import { getAnnouncementsAction } from "../components/Tabs/Announcements/store/actions";
import { getApiData } from "../components/Tabs/LiveClasses/store/actions";
import { CONTENT_LIMIT } from "../components/Tabs/Content/store/constants";
import { TAB_BAR_ENUMS } from "../components/UIElements/TabBar/store/constants";
import { hitDeeplinkPerformAction } from "@src/utils/hitDeeplink";
import {
  COMMON_DEEPLINK_ACTIONS,
  TAZAYPAY_PAYMENT_STATUS,
  USER_AGENT_STRING,
} from "@src/utils/constants";
import toast from "react-hot-toast";
import { t } from "i18next";
import { getUserAgent } from "@src/utils/getAxiosConfig";
import { safeJsonParse } from "@src/utils/safeJsonParse";
import DoubtBudyButton from "./DoubtBudyButton";

const Layout = ({
  layoutProps: {
    noHeader,
    accent,
    title,
    withRecentActivity, //TODO REMOVE IF NOT NEEDED
    blockHeader,
    handleBack,
    noFooter,
    noPullToRefresh,
  },
  pageProps,
  children,
}) => {
  // console.log(pageProps);

  // const {
  //   getCourseCouponListStudentData: getCourseCouponListStudentDataServer,
  //   overviewData: overviewDataServer,
  // } = pageProps?.props;

  // console.log(
  //   "!!!!!",
  //   getCourseCouponListStudentDataServer,
  //   overviewDataServer
  // );

  const dispatch = useDispatch();
  // LOCAL STATE
  const [value, setValue] = useState(0);
  // REF FOR LAYOUT FOOTER
  const headerRef = useRef();
  const contentRef = useRef();
  const footerRef = useRef();

  // NEXTJS ROUTER
  const router = useRouter();

  // SELECTOR
  const bottomSheetReducer = useSelector((state) => state?.bottomSheetReducer);
  const meta  = useSelector((state) => state?.overviewReducer?.overViewDetails?.course?.metaData);
  const graphCouponListData = useSelector(
    (state) => state?.overviewReducer?.graphCourseCouponListData
  );

  const currentCouponCode =
    graphCouponListData?.coupons && graphCouponListData?.coupons?.[0];

  const tabIdArray = useSelector(
    (state) => state?.tabBarReducer?.tabList?.map((tab) => tab?.id) || []
  );

  const showSuggestions = useSelector(
    (state) => state?.layoutReducer?.showSuggestions
  );
  // STATES
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [marginTop, setMarginTop] = useState(0);
  const lastScrollTop = useRef(0);

  useEffect(() => {
    setFooterHeight(footerRef?.current?.offsetHeight || 0);
  }, [footerRef?.current?.offsetHeight]);

  useEffect(() => {
    setHeaderHeight(headerRef?.current?.offsetHeight);
  }, [headerRef?.current?.offsetHeight]);

  useEffect(() => {
    // contentRef.current.scrollTo(0, 0);
    contentRef.current.scrollTop = 0;
    setMarginTop(0);
    forceUpdate();
  }, [router.asPath]);

  const forceUpdate = () => {
    setValue((val) => val + 1);
  };

  useEffect(() => {
    if (!showSuggestions) {
      forceUpdate();
    }
  }, [showSuggestions]);

  const [isIOS, setIsIOS] = React.useState(false);
  React.useEffect(() => {
    const userAgent = window?.navigator?.userAgent?.toLowerCase();
    const ios = /iphone|ipod|ipad/?.test(userAgent);
    setIsIOS(ios);
    // setIsIOS(getUserAgent() == USER_AGENT_STRING.IOS);
  }, []);

  const handleLayoutScroll = () => {
    const currScroll = contentRef.current.scrollTop;
    const lastScroll = lastScrollTop.current;

    const userAgent = window?.navigator?.userAgent?.toLowerCase();
    const ios = /iphone|ipod|ipad/?.test(userAgent);

    const heightDiff =
      contentRef?.current?.scrollHeight -
      (contentRef?.current?.offsetHeight + contentRef?.current?.scrollTop);

    if (!blockHeader && !ios && heightDiff > 120) {
      if (marginTop <= 0 && marginTop >= -60) {
        // if (router?.query?.tabId == 1) {
        // OVERVIEW
        // if (currScroll > lastScroll) {
        //   // SCROLLUP
        //   // if (currScroll > 100 && currScroll < 250) {
        //   //   if (!layoutTitle) {
        //   //     setLayoutTitle(title || pageHeading);
        //   //   }
        //   // } else
        //   if (currScroll > 250) {
        //     if (marginTop > -60) {
        //       setMarginTop(marginTop - 5);
        //     }
        //   }
        //   // SCROLLUP
        // } else {
        //   // SCROLLDOWN
        //   if (marginTop < 0) {
        //     setMarginTop(marginTop + 5);
        //   }

        //   // if (currScroll < 200) {
        //   //   setLayoutTitle(null);
        //   // }
        //   // SCROLLDOWN
        // }
        // OVERVIEW
        // } else {
        // OTHER TABS

        if (currScroll > lastScroll) {
          if (marginTop > -60) {
            setMarginTop(marginTop - 5);
          }
        } else {
          if (marginTop < 0) {
            setMarginTop(marginTop + 5);
          }
        }
        // OTHER TABS
        // }
      }

      // TOP - BOTTOM;
      if (currScroll === 0) {
        setMarginTop(0);
      }
      // else if (
      //   contentRef?.current?.offsetHeight + contentRef?.current?.scrollTop ===
      //     contentRef?.current?.scrollHeight &&
      //   currScroll !== 0
      // ) {
      //   setMarginTop(-60);
      // }

      // UPDATION
      lastScrollTop.current = currScroll;
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window?.location?.search);
    const paymentStatus = searchParams.get("paymentStatus");
    const orderId = searchParams.get("orderId");

    if (paymentStatus) {
      if (paymentStatus === "failed") {
        if (orderId) {

          dispatch(setPrevOrderId(orderId));
        }
        dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
      } else {
        checkPaymentStatus(orderId);
      }

      searchParams.delete("paymentStatus");
      searchParams.delete("orderId");

      const newUrl = window.location.pathname + "?" + searchParams.toString();

      router.replace(newUrl);
    }
  }, []);

  useEffect(() => {
    window.onMobileBackPressed = () => {
      if (window.__INTRO_VIDEO_BOTTOM_SHEET_OPEN__) {
        // If intro video sheet is open, close webview instead of sheet
        if (typeof window.quitWebviewDeeplink === "function") {
          window.quitWebviewDeeplink();
        } else if (window?.mobile?.performAction) {
          window.mobile.performAction?.("ACTION_CLOSE", null);
        } else if (window?.webkit?.messageHandlers?.stateEvents) {
          window.webkit.messageHandlers.stateEvents.postMessage("QUIT");
        }
        return;
      }
      handleBackEvent(handleBack);
    };
    // hitDeeplinkPerformAction(
    //   COMMON_DEEPLINK_ACTIONS.ACTION_WEB_BACK_EVENT_ADDED,
    //   null
    // );

    window.onOfflineVideoDownloadSuccess = () => {
      toast.success(
        t(
          "layout.index.fileDownloadSuccessToast",
          "File downloaded successfully."
        )
      );
    };

    window.handleRefreshCourseData = () => {
      // COPYING TAB ID ARRAY BEFORE UPDATING
      const prevTabIdArray = tabIdArray;

      // REFRESHING TAB LIST DATA
      if (router?.query?.courseId) {
        dispatch(
          getTabListAction({
            courseId: router?.query?.courseId,
            skipLoader: true,
          })
        );
      }

      // REFRESHING OVERVIEW DATA
      dispatch(
        getCourseDetailsAction({
          courseId: router?.query?.courseId,
          isLoading: false,
          showPaymentLoader: false,
        })
      );

      // REFRESHING COURSE CONTENT
      dispatch(
        getCourseContentAction({
          courseId: router.query.courseId,
          limit: CONTENT_LIMIT,
          folderId: router?.query?.folderId,
          skipLoader: true,
        })
      );

      // REFRESHING COURSE CONTENT
      dispatch(
        getTrialCourseContentAction({
          courseId: router.query.courseId,
          limit: CONTENT_LIMIT,
          folderId: router?.query?.folderId,
          skipLoader: true,
        })
      );

      // REFRESHING LIVE CLASS RECORDING DATA
      if (prevTabIdArray?.includes(TAB_BAR_ENUMS.liveClasses)) {
        dispatch(
          getApiData(CONSTANTS.LIVECLASSES_VIDEOSDATA_GET, {
            route: "course/live/list/videos",
            limit: 20,
            offset: 0,
            entityId: router?.query?.courseId,
            type: 2,
            currentList: [],
            searchParam: "",
          })
        );
      }

      // REFRESHING ANNOUNCEMENTS DATA
      if (prevTabIdArray?.includes(TAB_BAR_ENUMS.announcements)) {
        dispatch(
          getAnnouncementsAction({
            courseId: router?.query?.courseId,
            offset: 0,
            showLoader: true,
          })
        );
      }
    };

    window.onPaymentUpdated = (dataObj) => {
      forceUpdate();
      const data = safeJsonParse(dataObj, {
        source: "Layout [onPaymentUpdated]",
        fallback: null,
      });
      // Parse failure must not be treated as payment failure.
      if (!data) return;
      // alertJSON.stringify(dataObj));
      if (data?.status == 1) {
        //Payment success
        // alert("Payment Update Event ");
        // alert"Payment Success");

        checkPaymentStatus();
      } else {
        //Payment failed
        dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
        // alert"Payment Failed");
      }
    };

    // REFRESHING DATA ON WEBVIEW QUIT
    window.onWebviewQuit = (dataObj) => {
      // alert("onWebviewQuit");
      // alert(JSON.stringify(dataObj));

      if (dataObj) {
        // alert("dataObj found");
        // alert(dataObj);
        const responseData = safeJsonParse(dataObj, {
          source: "Layout [onWebviewQuit]",
          fallback: null,
        });
        // alert("responseData", JSON.stringify(responseData));
        if (!responseData) return;
        if (responseData?.paymentStatus == "INSTALLMENT_PAYMENT_SUCCESS") {
          // alert("hello");
          dispatch(updateIsInstallmentPaymentAction(true));
          dispatch(
            actionCreator.showCongratulationsBottomSheetAction({
              show: true,
            })
          );
        } else if (
          responseData?.paymentStatus == "INSTALLMENT_PAYMENT_FAILURE"
        ) {
          window.is_installment = true;
          dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
        }
      } else {
        // alert("else");
        window?.handleRefreshCourseData();
      }
    };

    window.onInternationalReloadScreen = (dataObj) => {
      const parsedJSONStatus = safeJsonParse(dataObj, {
        source: "Layout [onInternationalReloadScreen]",
        fallback: null,
      });
      // const parsedJSON = JSON.parse(dataObj);
      // const parsedJSONStatus = JSON.parse(parsedJSON?.internationalPaymentResponse);
      dispatch(actionCreator.showFullScreenLoaderAction(false));
      // Parse failure must not be treated as payment failure.
      if (!parsedJSONStatus) return;
      if (parsedJSONStatus?.paymentStatus === TAZAYPAY_PAYMENT_STATUS.SUCCESS) {
        dispatch(
          actionCreator.showCongratulationsBottomSheetAction({
            show: true,
          })
        );
      } else if (
        parsedJSONStatus?.paymentStatus === TAZAYPAY_PAYMENT_STATUS.PENDING
      ) {
        dispatch(actionCreator.showPaymentProcessingBottomSheetAction(true));
      } else {
        dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
      }
    };

    window.onMobileUpdate = (dataObj) => {
      const data = safeJsonParse(dataObj, {
        source: "Layout [onMobileUpdate]",
        fallback: null,
      });
      // Parse failure must not be treated as payment failure.
      if (!data) return;

      if (data?.status == 1) {
        //Payment success

        checkPaymentStatus();
      } else {
        //Payment failed
        dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
      }
    };
  });

  // useEffect(() => {
  //   setTimeout(() => {
  //     alert(`setTimeout`);
  //     window.onRefreshAccessToken = (dataObj) => {
  //       alert(`onRefreshAccessToken`);
  //       alert(dataObj);
  //       const parsedJSON = JSON.parse(dataObj);
  //       const accessToken = parsedJSON?.accessToken;
  //       alert(accessToken);
  //     }

  //     // FETCHING REFRESH TOKEN FROM NATIVE APP USING DEEPLINK
  // hitDeeplinkPerformAction(
  //   COMMON_DEEPLINK_ACTIONS.ACTION_GET_REFRESH_TOKEN,
  //   null,
  //   JSON.stringify({ screen: COMMON_DEEPLINK_ACTIONS.ACTION_GET_REFRESH_TOKEN })
  // );
  //   }, 5000)
  // }, [])

  const checkPaymentStatus = async (paramOrderId) => {
    let orderId = paramOrderId || window.localStorage.getItem("orderId");

    dispatch(actionCreator.showFullScreenLoaderAction(true));
    try {
      let response = await checkPaymentStatusGetService(orderId);
      // let responseJson = await response.json();
      // alert(JSON.stringify(response));

      // console.log("response", response?.data?.data?.state);

      let responseState = response?.data?.data?.state;

      if (responseState == "captured") {
        // alert("Payment Success from Api");
        // dispatch(actionCreator.)

        dispatch(
          actionCreator.showCongratulationsBottomSheetAction({
            show: true,
            bottomCard: response?.data?.data?.bottomCard,
          })
        );
        dispatch(actionCreator.showFullScreenLoaderAction(false));
      } else if (responseState == "failure" || responseState == "failed") {
        // alert("Payment Failure Api from Api");
        dispatch(setPrevOrderId(orderId));
        dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
        dispatch(actionCreator.showFullScreenLoaderAction(false));
      } else if (responseState == "pending") {
        // alert("Pending");
        dispatch(actionCreator.showPaymentProcessingBottomSheetAction(true));
        dispatch(actionCreator.showFullScreenLoaderAction(false));
      }
    } catch (err) {
      // console.log("paymenterror", err);
      // alert("error", JSON.stringify(err));
      dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
    }
  };

  const socialLinks = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.socialLinks
  );

  // FUNCTION TO CHECK IF BOTTOM SHEET IS OPEN
  const isBottomSheetOpen = () => {
    return Object.keys(bottomSheetReducer).some(
      (i) => bottomSheetReducer[i] && typeof bottomSheetReducer[i] !== "object"
    );
  };

  // FUNCION TO DETERMINE TO SHOW PULL TO REFRESH OR NOT
  const showPullToRefresh = () => {
    if (noPullToRefresh) return false;
    if (isBottomSheetOpen()) return false;
    return true;
  };

  return (
    <div className={styles.layout}>
      {!noHeader && (
        <LayoutHeader
          accent={accent}
          ref={headerRef}
          marginTop={marginTop}
          handleBack={handleBack}
          pageHeadingServer={
            pageProps?.props?.overviewData?.course?.details?.name
          }
        />
      )}
      {showPullToRefresh() && <PullToRefresh layoutContentNode={contentRef} />}
      <LayoutContent
        ref={contentRef}
        // height={`calc(100vh - ${footerHeight + headerHeight}px - ${marginTop}px)`}
        height={`-webkit-calc(100vh - ${isIOS ? "env(safe-area-inset-top)" : "0px"
          } - ${isIOS ? "env(safe-area-inset-bottom)" : "0px"} - ${footerHeight + headerHeight
          }px - ${marginTop}px)`}
        onScroll={handleLayoutScroll}
      >
        {children}
      </LayoutContent>
      {meta?.bundleData?.isDoubtBuddyEnabled === 1 ? <DoubtBudyButton meta={meta} /> : null }

      <div className={styles.layout__footer} ref={footerRef}>
        {!noFooter ? (
          <LayoutFooter
            getCourseCouponListStudentDataServer={
              pageProps?.props?.getCourseCouponListStudentData || {}
            }
            overviewDataServer={pageProps?.props?.overviewData || {}}
            update={setValue}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Layout;
